export default __webpack_public_path__ + "5c3c27ce51535d1ee6cd3c037a8fb78d.png";